import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from '../../components/LoginModal/LoginModal';
import SignUpModal from '../../components/SignUpModal/SignUpModal';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [showSignUp, setShowSignUp] = useState(false);

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  const handleSignUpClick = () => {
    setShowSignUp(true);
  };

  const handleLoginClick = () => {
    setShowSignUp(false);
  };

  return (
    <>
      <LoginModal
        isOpen={!showSignUp}
        onClose={handleClose}
        onSignUpClick={handleSignUpClick}
      />
      <SignUpModal
        isOpen={showSignUp}
        onClose={handleClose}
        onLoginClick={handleLoginClick}
      />
    </>
  );
};

export default Login;
